import { ScheduleOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';


export default {
  path: '/collection-schedules',
  component: Layout,
  name: 'CollectionSchedule',
  meta: { title: 'collection_schedule_management', root: true, auth: AUTH_KEYS.COLLECTION_SCHEDULE_MANAGEMENT },
  children: [
    {
      path: '/collection-schedules',
      component: () => import('@/views/CollectionSchedule/List.vue'),
      meta: {
        title: 'collection_schedule_management',
        auth: AUTH_KEYS.COLLECTION_SCHEDULE_LIST,
        isHide: true,
      }
    },
    {
      path: '/collection-schedules/detail/:id',
      component: () => import('@/views/CollectionSchedule/Detail.vue'),
      meta: {
        title: 'collection_schedule_detail',
        isHide: true,
        auth: AUTH_KEYS.COLLECTION_SCHEDULE_DETAILS
      }
    }
  ]
};



